import React, { useRef } from 'react';
import { motion, useScroll } from 'framer-motion';
import { Search, UserPlus, LineChart, Rocket } from 'lucide-react';
import { Reveal, SectionHeading } from '../SectionHeading';
import { PROCESS } from '../../data/siteData';

const icons = [Search, UserPlus, LineChart, Rocket];

export const ProcessFlow = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start 70%', 'end 80%'] });

  return (
    <section data-testid="process-section" className="py-20 md:py-32 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading
          label="How WorkLynx Works"
          title="From Requirement to Delivery at Scale"
          subtitle="A structured four-step engagement model with visibility at every stage."
        />
        <div ref={ref} className="relative max-w-3xl mx-auto">
          <div className="absolute left-[27px] top-4 bottom-4 w-0.5 bg-slate-200" />
          <motion.div
            style={{ scaleY: scrollYProgress }}
            className="absolute left-[27px] top-4 bottom-4 w-0.5 bg-[#0066CC] origin-top"
          />
          <div className="space-y-12">
            {PROCESS.map((p, i) => {
              const Icon = icons[i];
              return (
                <Reveal key={p.step} delay={i * 0.12} data-testid={`process-step-${i + 1}`} className="relative flex gap-7">
                  <div className="relative z-10 w-14 h-14 rounded-full bg-white border-2 border-[#0066CC] flex items-center justify-center shrink-0 shadow-md">
                    <Icon className="w-5 h-5 text-[#0066CC]" />
                  </div>
                  <div className="pt-1">
                    <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#0066CC]">Step {p.step}</div>
                    <h3 className="text-lg md:text-xl font-semibold text-[#0A192F] font-heading mt-1">{p.title}</h3>
                    <p className="text-sm text-slate-600 mt-2 leading-relaxed max-w-xl">{p.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
